import React, { useCallback } from "react";
import "./modal.css";
import closeIcon from '@/assets/images/ic_close_black.svg';

const Modal = ({
  children,
  show,
  title = "",
  cancelText = "キャンセル",
  wrapClassName,
  titleClassName,
  onCancel,
  dataTestId = "modal",
}) => {
  const onCancelBtnClick = useCallback(() => {
    if (onCancel) onCancel();
  }, [onCancel]);

if(!show) return null;

  const renderModal = () => {
    return (
      <div className="modal" data-testid={dataTestId}>
        <div className={`content-wrap ${wrapClassName || ""}`}>
          <div className="content">
            {children || (
              <>
                <div 
                  className="close-btn" 
                  style={{
                    backgroundImage: `url(${closeIcon})` ,
                    backgroundPosition: "100%",
                    backgroundRepeat: "no-repeat"
                  }} 
                  onClick={onCancelBtnClick}
                />
                <div className={`title-wrap ${titleClassName || ""}`}>
                    {typeof title === "string" ? (
                      <span>{title}</span>
                    ) : (
                      <span dangerouslySetInnerHTML={title} />
                    )}
                </div>
                <div className="buttons-wrap">
                  <button
                    type="button"
                    className="button cancel-button"
                    onClick={onCancelBtnClick}
                  >
                    {cancelText}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return renderModal();
};

export default Modal;
